import {
  TestimonialCarousel as TestimonialCarouselZDS,
  TestimonialCarouselProps,
  TestimonialSoloProps,
  Img,
} from '@zapier/design-system';
import { RichTextHtml } from '../../RichTextHtml/RichTextHtml';
import { RichTextHTMLString } from '../types';
import { DEFAULT_VALUES } from './fixtures';
import { Video, VideoProps } from '../../../components/Video/Video';

type Testimonials = Array<
  Omit<TestimonialSoloProps, 'backgroundColor'> & {
    mediaURL: string;
    mediaAltText: string;
    video?: VideoProps;
  }
>;

export type Props = Omit<TestimonialCarouselProps, 'testimonials'> & {
  testimonials: Testimonials;
};

export function TestimonialCarousel({
  backgroundColor,
  testimonials = [],
}: Props) {
  return (
    <TestimonialCarouselZDS
      backgroundColor={backgroundColor || DEFAULT_VALUES.backgroundColor}
      testimonials={testimonials.map((testimonial) => {
        return {
          ...testimonial,
          quote: (
            <RichTextHtml
              backgroundColor={backgroundColor}
              html={testimonial.quote as RichTextHTMLString}
            />
          ),
          mediaElement:
            (testimonial.mediaURL && (
              <Img
                src={testimonial.mediaURL || ''}
                alt={testimonial.mediaAltText || ''}
              />
            )) ||
            (testimonial.video?.videoUrl && <Video {...testimonial.video} />),
        };
      })}
    />
  );
}
